// extracted by mini-css-extract-plugin
var _1 = "Checkbox_checkbox__CGsG6";
var _2 = "Checkbox_customCheckbox__F+KQy";
var _3 = "Checkbox_label__InenQ";
export { _1 as "checkbox", _2 as "customCheckbox", _3 as "label" }
